import { useToggleState } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openLeaveContactsModal } from '../../actions/leaveContacts/actions';
import { HeroSection } from '../../components/HeroSection';
import { VideoPlaybackModal } from '../../components/VideoPlaybackModal';
import { selectDealProcessVideoIframeUrl } from '../../selectors/links';
import { trackScrollToCallToAction } from '../../utils/analytics/trackScrollToCallToAction';
import { pipe } from '../../utils/pipe/pipe';
import { trackWatchVideoClick } from './tracking';

export const HeroSectionContainer = () => {
  const dispatch = useDispatch();
  const onOpenLeaveContactsModal = () => void dispatch(openLeaveContactsModal());
  const deviceType = useDeviceType();
  const videoSrc = useSelector(selectDealProcessVideoIframeUrl);

  const { state: showVideoModalState, toggle: toggleVideoModalState } = useToggleState();

  return (
    <>
      <HeroSection
        deviceType={deviceType}
        onOpenVideoClick={pipe(toggleVideoModalState, trackWatchVideoClick)}
        onCreateDealClick={pipe(onOpenLeaveContactsModal, () => trackScrollToCallToAction('main'))}
      />
      <VideoPlaybackModal
        deviceType={deviceType}
        videoSrc={videoSrc}
        isOpen={showVideoModalState}
        onClose={toggleVideoModalState}
      />
    </>
  );
};
